import React, { useState } from 'react';
import { Link as RouterLink, withRouter, NavLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Badge,
  IconButton,
  Avatar,
  MenuList,
  MenuItem,
  Menu,
  ListItemText,
  Typography
} from '@material-ui/core';

import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Logo from '@assets/images/logo.png';
import NotifMenu from './NotifMenu';
import { news } from './fakeData';
// TODO: connect to redux and state
// TODO: avatar url
// TODO: notification popup

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    backgroundColor: '#FFF',
    borderBottom: '1px solid #d8d8d8',
    minHeight: '100px',
    justifyContent: 'center'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  logoWrapper: {
    maxWidth: '200px'
  },
  logo: {
    width: '100%'
  },
  menu: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    outline: 'none'
  },
  notification: {
    marginRight: '20px'
  },
  menuItemActive: {
    outline: 'none',
    borderBottom: 'solid #002380',
    borderBottomWidth: '0px solid #002380',
    marginTop: '3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'border-width 0.3s ease',

    '& :hover': {
      borderWidth: '3px'
    }
  },
  menuItem: {
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  link: {
    fontSize: '16px',
    fontFamily: 'PT Sans',
    fontWeight: '500'
  },
  linkActive: {
    fontSize: '16px',
    fontFamily: 'PT Sans',
    fontWeight: '600',
    color: '#002380'
  }
}));

const Topbar = (props) => {
  const { className, onSidebarOpen, location, items, ...rest } = props;

  const [anchorElNotification, setAnchorElNotification] = useState(null);
  const handleNotificationToggle = (event) =>
    setAnchorElNotification(event.currentTarget);
  const handleCloseNotification = () => setAnchorElNotification(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const handleSettingdToggle = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const handleLogout = () => {
    setAnchorEl(null);
    onSidebarOpen();
  };

  const classes = useStyles();

  const listItems = items.map((link, i) => {
    const isCurrentPath = location.pathname.indexOf(link.path) > -1;

    return (
      <RouterLink
        className={isCurrentPath ? classes.menuItemActive : classes.menuItem}
        to={link.path}>
        <MenuItem
          key={i}
          className={isCurrentPath ? classes.linkActive : classes.link}
          onClick={null}>
          {link.name}
        </MenuItem>
      </RouterLink>
    );
  });

  return (
    <AppBar {...rest} className={clsx(classes.root, className)}>
      <Toolbar>
        <div className={classes.logoWrapper}>
          <RouterLink to="/">
            <img
              alt="Praexo"
              className={classes.logo}
              src={Logo}
              title="Praexo"
            />
          </RouterLink>
        </div>

        <MenuList className={classes.menu}>{listItems}</MenuList>

        <div className={classes.flexGrow} />

        <>
          <IconButton
            className={classes.notification}
            color="secondary"
            onClick={handleNotificationToggle}>
            <Badge badgeContent={news.length} color="primary">
              <NotificationsIcon />
            </Badge>
          </IconButton>

          <IconButton color="secondary">
            <Avatar
              alt="Andre M"
              src="https://form-physic.com/wp-content/uploads/2019/03/avatar-1.jpg"
            />

            <KeyboardArrowDown />
          </IconButton>
        </>
        <NotifMenu
          anchorElNotification={anchorElNotification}
          onClose={handleCloseNotification}
        />
        <Menu
          anchorEl={anchorEl}
          className={classes.popOver}
          id="user-menu"
          onClose={handleCloseMenu}
          open={Boolean(anchorEl)}>
          <MenuItem onClick={handleCloseMenu}>
            <ListItemText primary="Profile" />
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemText primary="Sign out" />
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  items: PropTypes.any.isRequired,
  onSidebarOpen: PropTypes.func.isRequired
};

export default withRouter(Topbar);
